<template>
<div class="animated fadeIn mt-5" v-if="dataLoaded">
  <form enctype="multipart/form-data" v-on:submit="validateBeforeSubmit($event,false)">
    <div class="row">
      <b-col md="6">
        <b-card>
          <div slot="header">
            <strong>Refazer vendas Sellin</strong>
          </div>
          <b-form-row>

            <b-form-group label="Desde:" >
              <b-form-input type="date" name="remakeFrom" v-model="item.remakeFrom" placeholder="2020XX"  v-validate="'required'" :state="validateState('remakeFrom')"></b-form-input>
              <b-form-invalid-feedback>
                {{ errors.first('remakeFrom') }}
              </b-form-invalid-feedback>
            </b-form-group>
          </b-form-row>


          <div slot="footer">
            <div class="row">
              <div class="col-sm-9 text-right">
                <b-button type="submit" size="sm" variant="primary"><i class="fa fa-save"></i> Refazer</b-button>
              </div>
            </div>
          </div>
        </b-card>


      </b-col>
      <b-col md="6">
        <b-card>
          <div slot="header">
            <strong>Debug </strong>
          </div>
          <pre>{{ item }}
          </pre>

        </b-card>
      </b-col>
      <!--/.col-->
    </div>
  </form>

</div>
</template>

<script>
import lists from '@/components/States.js'
export default {
  name: 'ImportExtras',
  props: ['id'],
  components: {},
  data() {
    return {
      lists: lists,
      item: {
        remakeFrom: ''
      }
    }
  },
  methods: {
    validateBeforeSubmit(evt, close) {
      evt.preventDefault()
      console.log('check validation')
      this.$validator.validateAll().then((result) => {
        console.log('validation results:', result)
        if (result) {
          console.log('all fields ok. submit')
          this.submit(evt, close)
          return
        }
        this.$bvToast.toast(`Tem campos inválidos`, { autoHideDelay: 5000, variant: 'danger', solid: true })
      })
    },
    validateState(ref) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
        return !this.errors.has(ref)
      }
      return null
    },
    submit(e, close) {
      e.preventDefault()
      var data = {
        data: this.item
      }
      this.axios.post('sales/remake/sellin', data)
        .then(response => {
          this.$bvToast.toast(`Vendas refeitas com sucesso`, { autoHideDelay: 5000, variant: 'success', solid: true })
        })
        .catch(response => {
          this.$bvToast.toast(`Não foi possivel gravar`, { autoHideDelay: 5000, variant: 'danger', solid: true })
        })
    }
  },
  created() {
    this.dataLoaded = true
  }
}
</script>
